import React from 'react';
import { useSearchParams } from 'react-router';

import useCanAccessUsageInsights from '../../common/hooks/useCanAccessUsageInsights';
import InvalidUrl from '../../component/authentication/InvalidUrl';

const UserUsagePage = React.lazy(() => import('../../component/licensing/userUsage/UserUsagePage'));

/**
 * Lazy entry-point for the User usage page. The route is registered in
 * `usePrivateShellRoutes` only when `EnableUserUsageView` is on, so no
 * further flag gating is needed here. The plan check is repeated, though: a
 * Community organization must not reach the page even if the route ever gets
 * registered from somewhere else.
 *
 * The `unit` query param (PLTU / AGU) is set by the entry card based on the
 * org's consumables and threaded down here as a prop so the page itself
 * doesn't need to know about routing.
 */
export const UserUsageRoute: React.FC = () => {
    const [ searchParams ] = useSearchParams();
    const canAccessUsageInsights = useCanAccessUsageInsights();
    const unitCode = searchParams.get('unit') ?? undefined;

    if (!canAccessUsageInsights) {
        return <InvalidUrl />;
    }

    return <UserUsagePage unitCode={unitCode} />;
};
